import { NodeConfig } from "../../KnowledgeGraph/index";

export const defaultNodeConfig: Required<NodeConfig> = {
  fill: "#1890ff",
  nameColor: "#666666",
  typeColor: "#ffffff",
  nameSize: 10,
  typeSize: 10,
  hoverStyle: {
    fill: "#23ff45",
  },
  radius: 20,
};
